<template>
  <div id="leave-modal">
    <form @submit="confirm">
      <div class="message-wrapper">
        <div>
          <i class="fa-light fa-exclamation-circle"></i>
          <h2 v-html="title"></h2>
        </div>
        <p class="text-muted" v-html="description"></p>
      </div>

      <div class="footer" :class="{ reverse: reverse }">
        <div :class="{ reverse: reverse }">
          <button
            type="submit"
            class="btn left-side"
            :class="confirmBtnPrimaryColor ? 'btn-primary ' : 'btn-secondary'"
            @click="confirm"
            v-html="confirmButtonText || 'Ok'"
          ></button>
          <button ref="focus" type="reset" v-if="!hideCancelButton" class="btn btn-secondary" @click="cancelClick">
            {{ $t("confirm-modal.cancel") }}
          </button>
        </div>
        <button
          v-if="thirdOption"
          class="btn third-option"
          :class="thirdColorBtnPrimary ? ' btn-primary' : ' btn-secondary'"
          v-html="thirdOptionText || 'Ok'"
          @click="thirdOptionClick"
          :disabled="waiting"
        ></button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      waiting: false
    };
  },
  props: {
    title: String,
    description: String,
    confirmButtonText: String,
    onConfirm: Function,
    hideCancelButton: Boolean,
    onCancel: Function,
    thirdOption: Boolean,
    thirdOptionText: String,
    onThirdOptionClick: Function,
    thirdColorBtnPrimary: Boolean,
    confirmBtnPrimaryColor: {
      type: Boolean,
      default: false
    },
    reverse: {
      type: Boolean,
      default: false
    }
  },
  computed: {},
  methods: {
    confirm(evt) {
      evt.preventDefault();
      if (this.onConfirm) this.onConfirm();
      this.$emit("close");
    },

    cancelClick(evt) {
      console.log(this.$refs.focus);
      evt.preventDefault();
      if (this.onCancel) this.onCancel();
      this.$emit("close");
    },

    thirdOptionClick(evt) {
      evt.preventDefault();
      if (this.onThirdOptionClick) this.onThirdOptionClick();
      this.$emit("close");
    }
  },
  mounted() {
    this.$refs.focus.focus();
  }
};
</script>

<style lang="less">
#leave-modal form {
  display: flex;
  flex-direction: column;
  p {
    max-width: 350px;
    margin: 0;
  }
  button {
    margin-right: 10px;
  }
  .footer {
    padding: 20px;
    display: flex;
    justify-content: space-between;

  }
    .reverse {
      display: flex;
      flex-direction: row-reverse;
    }
  .left-side {
    // margin-left: 100px;
  }
  .message-wrapper {
    display: flex;
    flex-direction: column;
    // justify-content: space-between;
    padding: 20px 20px 0 20px;
    div {
      display: flex;
      align-items: center;
      gap: 12px;
      h2 {
        margin: 0;
      }
      svg {
        color: var(--flame);
        font-size: 38px;
      }
    }
  }
}
</style>
